export const actionTypes = {
  SET_DATA: 'TAPS.ATTACHMENTS.SET_DATA',
  GET_DATA: 'TAPS.ATTACHMENTS.GET_DATA',
  RESET: 'TAPS.ATTACHMENTS.RESET',
};

export function setAttachments(data) {
  return {
    type: actionTypes.SET_DATA,
    payload: data,
  };
}

export function getAccountData() {
  return {
    type: actionTypes.GET_DATA,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}
